module.exports = __webpack_public_path__ + "img/hcdl_gallery4.90015c9d.jpg";